import { makeStyles } from '@mui/styles'
const useStylesAddUserInOrganization = makeStyles(() => ({
  backgroundBox: {
    width: '100%'
  },
  mainBox: {
    marginLeft: '5%',
    width: '90%',
    marginTop: '6%'
  },
  addUsertypography: {
    mt: 2,
    mb: 1,
    fontWeight: 'bold'
  },
  instructionsTypography: {
    mt: 2,
    mb: 1,
    color: '#2C3532',
    marginTop: '2%'
  },
  fieldsTypography: {
    mt: 2,
    mb: 1,
    fontSize: 14,
    marginTop: '2%',
    marginBottom: '2%',
    marginLeft: '2%'
  },
  selectTypography: {
    fontSize: 14,
    mt: 1,
    mb: 1,
    ml: 1,
    marginTop: '2%',
    marginLeft: '2%'
  },
  boxButton: {
    position: 'absolute',
    width: '95%',
    marginLeft: '5%',
    bottom: 20,
    display: 'flex'
  },
  addUserButton: {
    width: 90,
    height: 35,
    backgroundColor: '#1C846F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  addUserButtonTypography: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16
  },
  cancelButton: {
    width: 90,
    height: 35,
    marginLeft: 10,
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  cancelButtonTypography: {
    color: '#262626',
    cursor: 'pointer',
    fontSize: 16
  },
  formControlStyle: {
    width: '70%',
    marginLeft: 10
  }
}))

export default useStylesAddUserInOrganization
